import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awards',
  templateUrl: './awards.component.html',
  styleUrls: ['./awards.component.scss']
})
export class AwardsComponent implements OnInit {

  awards = [
    { title: 'Award Ceremony', body: '', img: '/assets/img/quick-links/awards/1 (1).jpg' },
    { title: 'Award Ceremony', body: '', img: '/assets/img/quick-links/awards/1 (2).jpg' },
    { title: 'Award Ceremony', body: '', img: '/assets/img/quick-links/awards/1 (3).jpg' },
    { title: 'Award Ceremony', body: '', img: '/assets/img/quick-links/awards/1 (4).jpg' },
    { title: 'Award Ceremony', body: '', img: '/assets/img/quick-links/awards/1 (5).jpg' },
    { title: 'Award Ceremony', body: '', img: '/assets/img/quick-links/awards/1 (6).jpg' },
    { title: 'Award Ceremony', body: '', img: '/assets/img/quick-links/awards/1 (7).jpg' },
    { title: 'Award Ceremony', body: '', img: '/assets/img/quick-links/awards/1 (8).jpg' },
    { title: 'Award Ceremony', body: '', img: '/assets/img/quick-links/awards/1 (9).jpg' },
    { title: 'Award Ceremony', body: '', img: '/assets/img/quick-links/awards/1 (10).jpg' },
    { title: 'Award Ceremony', body: '', img: '/assets/img/quick-links/awards/1 (11).jpg' },
    { title: 'Award Ceremony', body: '', img: '/assets/img/quick-links/awards/1 (12).jpg' },
    { title: 'Award Ceremony', body: '', img: '/assets/img/quick-links/awards/1 (13).jpg' },
  ];

  constructor() { }

  ngOnInit(): void { }

}
